.iconButton {
	@apply
	yst-flex
	yst-gap-2
	yst-py-1;

	svg {
		@apply
		yst-inline
		yst-h-4
	}
}
